<template>
  <custom-plane
    title="水环境"
    :iconImg="require('@/assets/environment/water-env.png')"
  >
    <div class="air-content-top">
      <div class="air-item" v-for="item in waterArray">
        <div class="name">{{ item.name }}</div>
        <div class="detail">
          <div
            class="detail-num"
            :class="item.alarm == '0' ? '' : 'error-color'"
          >
            {{ item.num }}
          </div>
          <div class="detail-unit">
            {{ item.unit }}
          </div>
        </div>
      </div>
    </div>
  </custom-plane>
</template>

<script>
export default {
  props: {
    waterArray: Array,
  },
};
</script>

<style lang="scss" scoped>
.air-content-top {
  margin: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .air-item {
    width: 98px;
    height: 57px;
    white-space: nowrap;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .name {
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      color: #e5e5e5;
    }
    .detail {
      color: #2d82ff;
      font-weight: 500;
      font-family: "dina";
      display: flex;
      align-items: baseline;
      .feng-num {
        font-family: "source" !important;
        font-size: 22px !important;
      }
      .detail-num {
        font-size: 28px;
        line-height: 32px;
        font-family: "dina";
      }
      .detail-unit {
        font-size: 14px;
        font-family: "dina";
      }
    }
  }
}
</style>
